import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-447a1b14"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  class: "header-tip-container"
};
var _hoisted_2 = {
  key: "1"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "温馨提醒：请使用【最新版本的谷歌浏览器】继续考试", -1);
});
var _hoisted_4 = {
  key: "2"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, " 请使用谷歌浏览器，点击设置->隐私设置和安全性->权限->打开摄像头/麦克风 ", -1);
});
var _hoisted_6 = {
  key: "3"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "请更换摄像头和麦克风设备", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ExclamationCircleOutlined = _resolveComponent("ExclamationCircleOutlined");
  return _ctx.tip > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.tip === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_ExclamationCircleOutlined, {
    style: {
      "color": "#ffbf00",
      "font-size": "20px",
      "margin-right": "8px"
    }
  }), _hoisted_3, _createElementVNode("span", {
    class: "btn-open-browser",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return _ctx.downloadChrome && _ctx.downloadChrome.apply(_ctx, args);
    })
  }, " 下载谷歌浏览器 ")])) : _createCommentVNode("", true), _ctx.tip === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_ExclamationCircleOutlined, {
    style: {
      "color": "#ffbf00",
      "font-size": "20px",
      "margin-right": "8px"
    }
  }), _hoisted_5])) : _createCommentVNode("", true), _ctx.tip === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_ExclamationCircleOutlined, {
    style: {
      "color": "#ffbf00",
      "font-size": "20px",
      "margin-right": "8px"
    }
  }), _hoisted_7])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}